import { render, staticRenderFns } from "./landing-sidebar.vue?vue&type=template&id=186652ee"
import script from "./landing-sidebar.vue?vue&type=script&lang=js"
export * from "./landing-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports